export default __webpack_public_path__ + "static/media/shotgun-reload.30299b00.mp3";